import { Reducer } from "redux"
import { WhatsNewActionTypes, WhatsNewState } from "./whats-new-types"
import { NewsFeedItem } from "../../model/whats-new-model"

const initialState: WhatsNewState = {
    loading: false,
    error: null,
    items: [],
    isOpen: false,
}

export const whatsNewReducer: Reducer<WhatsNewState> = (
    state: WhatsNewState = initialState,
    action: any
) => {
    switch (action.type) {
        case WhatsNewActionTypes.API_ATTEMPT:
            return Object.assign({}, state, { loading: true, error: null })

        case WhatsNewActionTypes.API_FAILURE:
            return Object.assign({}, state, { loading: false, error: action.payload })

        case WhatsNewActionTypes.SET_FEED: {
            const items: NewsFeedItem[] = action.payload
            return Object.assign({}, state, { loading: false, error: null, items })
        }

        case WhatsNewActionTypes.SET_OPEN:
            return Object.assign({}, state, { isOpen: action.payload })

        default:
            return state
    }
}
